import { environment } from './app/environments/environment';

// KK-304: was `import('./bootstrap')` fired in parallel with this — a race
// where AppConfig.get('baseUrlAccess') etc. could read undefined if the app
// bootstrapped faster than this chunk resolved. Low probability (this is a
// small chunk vs. a full Angular+Module Federation bootstrap) but free to
// close by just sequencing it.
import('MFEWidgetCore/AppConfig').then((module) => {
	module.AppConfig.setConfig(environment);
	return import('./bootstrap');
}).catch(err => console.error(err));
